/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";

function EditIcon({ width = 15, height = 14, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 14"
      fill="none"
      {...props}
    >
      <path
        d="M1.86145 14C1.43663 14 1.07462 13.8504 0.775438 13.5512C0.476253 13.2521 0.32666 12.89 0.32666 12.4652V3.11726C0.32666 2.69244 0.476253 2.33044 0.775438 2.03125C1.07462 1.73206 1.43663 1.58247 1.86145 1.58247H7.87845L6.34367 3.11726H1.86145V12.4652H11.2094V7.9742L12.7442 6.43943V12.4652C12.7442 12.89 12.5946 13.2521 12.2954 13.5512C11.9962 13.8504 11.6342 14 11.2094 14H1.86145ZM9.28344 2.08331L10.3254 3.10846L5.90113 7.52067V8.42554H6.78914L11.2263 3.99647L12.2562 5.01354L7.40695 9.87965H4.44703V6.91973L9.28344 2.08331ZM12.2562 5.01354L9.28344 2.08331L10.9095 0.457245C11.217 0.149751 11.5846 -0.00265234 12.0124 3.49218e-05C12.4401 0.00273343 12.8021 0.157824 13.0984 0.465307L13.8735 1.25324C14.1643 1.55218 14.3098 1.91136 14.3098 2.3308C14.3098 2.75025 14.1617 3.10809 13.8654 3.40433L12.2562 5.01354Z"
        fill="black"
      />
    </svg>
  );
}

export default EditIcon;
